import PageMeta from "../components/common/PageMeta";
import PageContainer from "../components/common/PageContainer";
import PageHeader from "../components/common/PageHeader";
import CheckoutChampPaymentsCoverage from "../components/dashboard/CheckoutChampPaymentsCoverage";

export default function CheckoutChampTransactionsPage() {
  return (
    <div>
      <PageMeta
        title="Chargemont | CheckoutChamp Transactions"
        description="CheckoutChamp transactions coverage and import status"
      />
      <PageContainer>
        <PageHeader title="CheckoutChamp Transactions" />
        <CheckoutChampPaymentsCoverage />
      </PageContainer>
    </div>
  );
}
